// statistics.service.ts
import { AxiosResponse } from "axios";
import api from "./api";
import i18n from "../i18n";

export interface IStatistics {
  owners: {
    total: number;
    active: number;
    inactive: number;
    pendingApproval: number;
  };
  carWashes: {
    total: number;
    active: number;
    inactive: number;
    pendingReview: number;
  };
  washes: {
    total: number;
    pending: number;
    inProgress: number;
    completed: number;
    completedToday: number;
    completedThisWeek: number;
    completedThisMonth: number;
  };
  users: {
    total: number;
    active: number;
  };
  washers: {
    total: number;
    active: number;
  };
  reviews: {
    pending: number;
    total: number;
    approvedToday: number;
  };
  revenue: {
    totalCommission: number;
    commissionToday: number;
    commissionThisWeek: number;
    commissionThisMonth: number;
  };
}

export interface IRMStats {
  owners: {
    total: number;
    online: number;
    onlineEmployees: number;
    pending: number;
    withoutEmployee: number;
  };
  carWashes: { total: number; pending: number };
}

interface IStatisticsResponse {
  status: string;
  data: IStatistics;
}

class StatisticsService {
  /**
   * Get all dashboard statistics
   */
  public async getDashboardStats(): Promise<IStatistics> {
    try {
      const response: AxiosResponse<IStatisticsResponse> =
        await api.get<IStatisticsResponse>("/admins/statistics");
      return response.data.data;
    } catch (error: any) {
      this.handleError(error, i18n.t("serviceErrors.fetchStatistics"));
    }
  }

  /**
   * Get RM-scoped dashboard stats
   */
  public async getRMStats(): Promise<IRMStats> {
    try {
      const response: AxiosResponse<{ status: string; data: IRMStats }> =
        await api.get("/admins/dashboard/rm-stats");
      return response.data.data;
    } catch (error: any) {
      this.handleError(error, i18n.t("serviceErrors.fetchRMStats"));
    }
  }

  /**
   * Error handling method
   */
  private handleError(error: any, defaultMessage: string): never {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || defaultMessage);
    } else {
      throw new Error(i18n.t("serviceErrors.serverError"));
    }
  }
}

const statisticsServiceInstance = new StatisticsService();
export default statisticsServiceInstance;
